<template>
  <div class="main-panel">
    <div class="settings-container-v4">
      <!-- Header -->
      <div class="page-header-v2">
        <div>
          <h2 class="page-title-v2"><i class="fa fa-cogs me-2"></i>Налаштування</h2>
          <p class="page-subtitle-v2">Керування обліковим записом та конфігуратором</p>
        </div>
      </div>

      <div class="card settings-card">
        <div class="card-header">
          <!-- Tabs -->
          <ul class="nav nav-tabs card-header-tabs" id="settingsTabs" role="tablist">
            <li class="nav-item">
              <a class="nav-link" :class="{ active: activeTab === 'config' }" @click="setActiveTab('config')" href="#"
                role="tab">
                Налаштування конфігуратора
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: activeTab === 'password' }" @click="setActiveTab('password')"
                href="#" role="tab">
                Зміна паролю
              </a>
            </li>
          </ul>
        </div>

        <!-- Tab Content -->
        <div class="card-body">
          <div class="tab-content" id="settingsTabsContent">
            <!-- Configurator Settings Tab -->
            <div class="tab-pane" :class="{ 'show active': activeTab === 'config' }" id="config" role="tabpanel">
              <form class="needs-validation" novalidate>
                <div class="form-group form-group-v2">
                  <div class="form-check form-switch">
                    <input type="checkbox" class="form-check-input" id="with_edge_sizes"
                      v-model="localConfig.with_edge_sizes">
                    <label class="form-check-label" for="with_edge_sizes">Розмір з кромкою</label>
                  </div>
                </div>
                <div class="form-group form-group-v2">
                  <div class="form-check form-switch">
                    <input type="checkbox" class="form-check-input" id="show_edge_sides_count"
                      v-model="localConfig.show_edge_sides_count">
                    <label class="form-check-label" for="show_edge_sides_count">Кількість обклеюваних сторін</label>
                  </div>
                </div>
                <div class="form-group form-group-v2">
                  <div class="form-check form-switch">
                    <input type="checkbox" class="form-check-input" id="allow_no_price"
                      v-model="localConfig.allow_no_price">
                    <label class="form-check-label" for="allow_no_price">Використовувати матеріал і кромку без ціни.
                      Остаточна сума та дата готовності замовлень буде уточнена менеджером.</label>
                  </div>
                </div>
                <hr>
                <button :disabled="configLoading" type="button" @click="saveConfig" class="btn btn-primary">
                  <span v-show="configLoading" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
                  {{ configLoading ? "Зберігаємо..." : "Зберегти" }}
                </button>
              </form>
            </div>

            <!-- Password Change Tab -->
            <div class="tab-pane" :class="{ 'show active': activeTab === 'password' }" id="password" role="tabpanel">
              <form class="needs-validation" novalidate>
                <div class="password-field-group">
                  <label for="oldPassword">Старий пароль</label>
                  <div class="password-input-wrapper">
                    <input :type="types.old_password" v-model="form.old_password"
                      :class="['password-input', { 'has-error': errors?.old_password }]" id="oldPassword"
                      placeholder="Введіть старий пароль">
                    <button type="button" @click="switchType('old_password')" class="password-toggle-btn">
                      <i :class="types.old_password === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                    </button>
                  </div>
                  <div class="error-message" v-if="errors?.old_password">{{ errors.old_password[0] }}</div>
                </div>

                <div class="password-field-group">
                  <label for="password">Новий пароль</label>
                  <div class="password-input-wrapper">
                    <input :type="types.new_password" v-model="form.new_password"
                      :class="['password-input', { 'has-error': errors?.new_password }]" id="password"
                      placeholder="Введіть новий пароль">
                    <button type="button" @click="switchType('new_password')" class="password-toggle-btn">
                      <i :class="types.new_password === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                    </button>
                  </div>
                  <div class="error-message" v-if="errors?.new_password">{{ errors.new_password[0] }}</div>
                </div>

                <div class="password-field-group">
                  <label for="new_password_confirmation">Підтвердження нового паролю</label>
                  <div class="password-input-wrapper">
                    <input :type="types.new_password_confirmation" v-model="form.new_password_confirmation"
                      :class="['password-input', { 'has-error': errors?.new_password_confirmation }]"
                      id="new_password_confirmation" placeholder="Підтвердіть новий пароль">
                    <button type="button" @click="switchType('new_password_confirmation')" class="password-toggle-btn">
                      <i :class="types.new_password_confirmation === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                    </button>
                  </div>
                  <div class="error-message" v-if="errors?.new_password_confirmation">
                    {{ errors.new_password_confirmation[0] }}
                  </div>
                </div>

                <hr>
                <button :disabled="loading" type="button" @click="changePassword" class="btn btn-primary">
                  <span v-show="loading" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
                  {{ loading ? "Змінюємо..." : "Змінити пароль" }}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      activeTab: 'config', // Добавляем реактивное состояние для активной вкладки
      types: {
        'old_password': 'password',
        'new_password': 'password',
        'new_password_confirmation': 'password',
      },
      form: {
        'old_password': '',
        'new_password': '',
        'new_password_confirmation': '',
      },
      loading: false,
      configLoading: false,
      errors: {},
      localConfig: {
        with_edge_sizes: false,
        show_edge_sides_count: false,
        allow_no_price: false
      }
    }
  },
  computed: {
    ...mapState({
      storeConfig: state => state.auth.settings
    })
  },
  methods: {
    ...mapActions({
      loadUserData: 'auth/loadUserData'
    }),
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    handleHashNavigation() {
      const hash = this.$route.hash;
      if (!hash) return;

      // Определяем активный таб на основе хеша
      switch (hash) {
        case '#config':
          this.activeTab = 'config';
          break;
        case '#password':
          this.activeTab = 'password';
          break;
        default:
          return;
      }
    },
    switchType(field) {
      this.$set(this.types, field, this.types[field] === "password" ? "text" : "password");
    },
    changePassword(v) {
      this.loading = true;
      this.errors = {};
      axios.post('/user/password/change', this.form)
        .then(response => response.data)
        .then((response) => {
          this.loading = false;
          if (response.success) {
            this.$toast.success(response.message)
          } else {
            this.$toast.error(response.message)
          }
        }).catch(error => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
          } else {
            this.$toast.error('Щось пішло не так =(')
          }
          this.loading = false;
        })
    },
    saveConfig() {
      this.configLoading = true;
      axios.post('/user/settings/change', this.localConfig)
        .then(response => response.data)
        .then((response) => {
          this.configLoading = false;
          if (response.success) {
            this.$toast.success('Налаштування збережено')
            this.loadUserData(); // Перезагружаем данные пользователя после сохранения
          } else {
            this.$toast.error(response.message)
          }
        }).catch(error => {
          this.$toast.error('Щось пішло не так =(')
          this.configLoading = false;
        })
    }
  },
  mounted() {
    this.loadUserData().then(userData => {
      if (userData && userData.settings) {
        this.localConfig = {
          with_edge_sizes: userData.settings.with_edge_sizes || false,
          show_edge_sides_count: userData.settings.show_edge_sides_count || false,
          allow_no_price: userData.settings.allow_no_price || false
        };
      }
    });
    this.handleHashNavigation();
  },
  watch: {
    '$route.hash'() {
      this.handleHashNavigation();
    }
  },
  name: "settings"
}
</script>

<style scoped>
/* Main Layout */
.main-panel {
  background-color: #fff;
  min-height: 100vh;
}

.settings-container-v4 {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

/* Header */
.page-header-v2 {
  margin-bottom: 2rem;
}

.page-title-v2 {
  font-size: 1.75rem;
  font-weight: 600;
  color: #212529;
  display: flex;
  gap: 10px;
}

.page-subtitle-v2 {
  font-size: 1rem;
  color: #6c757d;
}

/* Settings Card */
.settings-card {
  border: none;
  border-radius: 0.75rem;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  /* Ensures child rounded corners */
}

.settings-card .card-header {
  background-color: #fff;
  padding: 0;
  border-bottom: 1px solid #dee2e6;
}

.settings-card .card-body {
  padding: 2rem;
}

/* Tabs */
.nav-tabs {
  border-bottom: none;
}

.nav-tabs .nav-item {
  margin-bottom: 0;
}

.nav-tabs .nav-link {
  border: none;
  border-bottom: 3px solid transparent;
  color: #6c757d;
  font-weight: 500;
  padding: 1rem 1.5rem;
  transition: all 0.2s ease-in-out;
}

.nav-tabs .nav-link:hover {
  color: #212529;
}

.nav-tabs .nav-link.active {
  color: #212929;
  font-weight: 600;
  border-bottom: 3px solid #ff182d;
  background-color: #fff;
  margin-bottom: 2px;
}

/* Form Styles */
.form-group-v2 {
  margin-bottom: 1rem;
}

.form-group-v2 label {
  font-weight: 500;
  margin-bottom: 0.25rem;
  color: #495057;
}

.form-control {
  padding: 0.5rem 0.75rem;
  /* Smaller padding for inputs */
  font-size: 0.9rem;
  /* Smaller font for inputs */
}

.form-check.form-switch {
  padding-left: 2.5rem;
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  /* Smaller margin for switches */
}

.form-check-label {
  padding-left: 0.5rem;
  font-size: 0.9rem;
  /* Smaller font for labels */
}

.form-check-input {
  width: 2em;
  height: 1.1em;
  margin-left: -2.5rem;
}

.form-check-input:checked {
  background-color: #ff182d;
  border-color: #ff182d;
}

hr {
  margin: 1.5rem 0;
}

/* Buttons */
.btn-primary {
  background-color: #ff182d;
  border-color: #ff182d;
  font-weight: 500;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
}

.btn-primary:hover {
  background-color: #d61527;
  border-color: #c01323;
}

/* Password Fields */
.password-field-group {
  margin-bottom: 1.5rem;
}

.password-field-group label {
  display: block;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #495057;
  font-size: 0.9rem;
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: stretch;
}

.password-input {
  flex: 1;
  padding: 0.5rem 3rem 0.5rem 0.75rem;
  font-size: 0.9rem;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 100%;
}

.password-input:focus {
  border-color: #ff182d;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 24, 45, 0.15);
}

.password-input.has-error {
  border-color: #dc3545;
}

.password-input.has-error:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.15);
}

.password-toggle-btn {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 2.5rem;
  background: transparent;
  border: none;
  color: #6c757d;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s ease-in-out;
  z-index: 3;
}

.page-header-v2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.password-toggle-btn:hover {
  color: #ff182d;
}

.password-toggle-btn:focus {
  outline: none;
}

.error-message {
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #dc3545;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.error-message::before {
  content: "⚠";
  font-weight: bold;
}
</style>